import React from 'react';
import { portfolioData } from '../data/portfolioData';

const Header = () => (
  <header className="header">
    <img src={portfolioData.profile.avatar} alt="Profile" className="avatar" />
    <div className="profile-info">
      <h1>{portfolioData.profile.name}</h1>
      <div className="website">
        <a href={`https://${portfolioData.profile.website}`} target="_blank" rel="noopener noreferrer">
          {portfolioData.profile.website}
        </a> |&nbsp;
        <a href={portfolioData.profile.resume} target="_blank" rel="noopener noreferrer">
          PDF Résumé
        </a>
      </div>
    </div>
    <div className="contact-info">
      <div>
        <a href={`mailto:${portfolioData.profile.email}`}>
          {portfolioData.profile.email}
        </a>
      </div>
      <div>
        <span className="method">telegram: </span> 
        <a href={`https://t.me/${portfolioData.profile.telegram.replace('@', '')}`} target="_blank" rel="noopener noreferrer">
          {portfolioData.profile.telegram}
        </a>
      </div>
      <div>
        <span className="method">line: </span> 
        <a href={`https://line.me/ti/p/${portfolioData.profile.line.replace('@', '')}`} target="_blank" rel="noopener noreferrer">
          {portfolioData.profile.line}
        </a>
      </div>
    </div>
  </header>
);

export default Header;